// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","fadeInFooter":"Footer_fadeInFooter__a-C8B"};